import RelevanceCompany from '@/components/relevanceCompany';
import Vue from 'vue';
import router from '@/router';
import store from '@/store/index.js';
/**
 * 打开弹窗
 * @param {Object} binding
 */
var openDialog = function openDialog(binding) {
  var PopupComponent = Vue.extend(RelevanceCompany);
  var instance = new PopupComponent({
    propsData: {
      visible: true,
      message: binding.value
    }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.$on('close', function () {
    document.body.removeChild(instance.$el);
    instance.$destroy();
  });
  instance.$on('add', function () {
    instance.$emit('close');
    router.push('/add');
  });
  instance.$on('success', function () {
    store.dispatch('user/getInfo');
    instance.$emit('close');
  });
  instance.$on('check', function (data) {
    instance.$emit('close');
    router.push({
      path: '/add',
      query: data
    });
  });
};
export default {
  bind: function bind(el, binding) {
    var handler = function handler() {
      openDialog(binding);
    };
    el.addEventListener('click', handler);
    el._clickHandler = handler;
  },
  unbind: function unbind(el) {
    el.removeEventListener('click', el._clickHandler);
  }
};